/* eslint-disable promise/catch-or-return, @typescript-eslint/no-floating-promises */
import('./bootstrap').then(({ bootstrap }) => bootstrap())
